<script lang="ts">
    import { onMount } from 'svelte'

    import { NPS } from '../../modules/toolsApi/nps/nps/nps'

    import { NPSRepository } from '../../modules/toolsApi/nps/nps/nps.repository'
    import { NPSService } from '../../modules/toolsApi/nps/nps/nps.service'

    const entityRep = new NPSRepository()
    const entityS = new NPSService(entityRep)

    let entity: NPS = new NPS()
    let npsOn: boolean = false
    let googleOn: boolean = false
    let googleEdit: boolean = false
    let address = ''
    let result: { name: string; place_id: string } = { name: '', place_id: '' }

    onMount(async () => {
        await loadNPS()
    })

    async function loadNPS() {
        entity = await entityS.getAll() // a api retorna no getall o token da empresa atual apenas (objeto, não array)
        npsOn = !!entity && !!entity.npsId && entity.status === 100
        googleOn = !!entity && !!entity.npsId && entity.googleOn
    }

    async function toggleNps() {
        if (!entity || !entity.npsId) {
            entity = await entityS.create({})
        } else {
            const status = npsOn ? 100 : 70
            entity = await entityS.update(entity.npsId, { status })
        }
    }

    async function toggleGoogle() {
        if (entity?.googlePlaceId) {
            const result = await entityS.update(entity.npsId, { googleOn })
        }
    }

    async function clearResult() {
        result.name = ''
        result.place_id = ''
    }

    async function searchPlace() {
        try {
            result = await entityS.getPlace(address)
            console.log('nps', result)
            if (!result || !result.place_id) {
                window.alert('Não foi possível encontrar os dados da empresa. Tente alterar suas palavras-chave.')
            }
        } catch (error) {
            window.error('Erro desconhecido ao requisitar dados. Caso o erro continue informe ao suporte.')
        }
    }

    async function changePlace() {
        googleEdit = true
        clearResult()
    }

    async function updatePlace() {
        const data = {
            googlePlaceId: result.place_id,
            googleName: result.name,
            googleOn: true,
        }
        entity = await entityS.update(entity.npsId, data)
        googleEdit = false
        clearResult()
    }
</script>

<div class="root">
    <div class="config-box mb-3">
        <div class="config-box-title">Zandu NPS</div>
        <div class="intro-label mb-2">
            Ative a pesquisa NPS para que o Zandu possa consultar junto aos clientes de sua empresa qual seu nível de
            satisfação.
        </div>
        <div class="form-check form-switch">
            <input
                class="form-check-input"
                bind:checked={npsOn}
                on:change={toggleNps}
                type="checkbox"
                role="switch"
                id="npsOn"
            />
            <label class="form-check-label" for="npsOn">Ativar a pesquisa NPS</label>
        </div>
    </div>
    <div class="config-box">
        <div class="config-box-title">Google Meu Negócio</div>
        <div class="intro-label mb-2">
            Ative a integração do Zandu NPS com o Google Meu Negócio e melhore sua avaliação pública (estrelas) no
            Google
        </div>
        <div class="form-check form-switch">
            <input
                class="form-check-input"
                bind:checked={googleOn}
                on:change={toggleGoogle}
                type="checkbox"
                role="switch"
                id="googleOn"
            />
            <label class="form-check-label" for="googleOn"> Ativar integração com Google Meu Negócio </label>
        </div>
        {#if googleOn}
            <div class="grid-form">
                {#if !entity?.googlePlaceId || googleEdit}
                    {#if result.place_id === ''}
                        <div class="input-group">
                            <label for="" class="input-group-text">Informe o nome de sua empresa e endereço</label>
                            <input type="text" bind:value={address} class="form-control" />
                            <button class="btn btn-secondary" type="button" on:click={searchPlace}>Buscar</button>
                        </div>
                        <div class="muted">
                            Separe cada segmento do endereço por vírugla. Ex.: Dom Barbearia e Café, Rua Dourados, 154,
                            Centro, São Paulo, SP
                        </div>
                    {:else}
                        <div class="result mt-1">
                            <div>
                                <b>{result.name}</b> é o nome de sua empresa?
                            </div>
                            <button class="btn btn-secondary" type="button" on:click={updatePlace}>Sim</button>
                            <button class="btn btn-secondary" type="button" on:click={clearResult}>Não</button>
                        </div>
                    {/if}
                {:else}
                    <div class="google-current">
                        Conectado com a empresa {entity.googleName}
                        <button class="btn btn-sm btn-secondary" on:click={changePlace}>Alterar</button>
                    </div>
                {/if}
            </div>
        {/if}
    </div>
</div>

<style>
    .root {
        max-width: 980px;
        margin: 0 auto;
        margin-top: 16px;
    }
    .intro-label {
        opacity: 0.8;
        font-weight: 300;
    }
    .result {
        display: flex;
        align-items: center;
    }
    .result > * {
        margin-right: 8px;
    }
    .google-current {
        margin-top: 8px;
    }
</style>
